<template>
   <div>
      <b-row align-v="center" class="my-4">
         <b-col md="auto">
            <b-pagination
                v-model="currentPageOrderList"
                :total-rows="orders.length"
                :per-page="10"
                aria-controls="my-table"
            ></b-pagination>
         </b-col>

         <b-col align-self="start">
            <b-form inline>
               <b-form-checkbox-group
                   id="checkbox-group-1"
                   v-model="selectedOrderType"
                   :options="[{ text: 'BULK', value: 'PRODUCTION' }, { text: 'SMS', value: 'SAMPLE' }]"
                   name="flavour-1"
               ></b-form-checkbox-group>

               <b-form-input
                   style="background-color: #F1F1F1; border: none;"
                   class="secondary mb-2 mr-sm-2 mb-sm-0"
                   id="filter"
                   name="filter"
                   type="text"
                   placeholder="Order Number"
                   v-model="customerOrderNumberFilter"
               ></b-form-input>

               <b-form-input
                   style="background-color: #F1F1F1; border: none;"
                   class="secondary mb-2 mr-sm-2 mb-sm-0"
                   id="filter"
                   name="filter"
                   type="text"
                   placeholder="PB Article"
                   v-model="articleFilter"
               ></b-form-input>
               <b-form-input
                   style="background-color: #F1F1F1; border: none;"
                   class="secondary mb-2 mr-sm-2 mb-sm-0"
                   id="filter"
                   name="filter"
                   type="text"
                   placeholder="Customer Article"
                   v-model="customerArticleFilter"
               ></b-form-input>

            </b-form>
         </b-col>
      </b-row>
      <b-table responsive striped small hover
               :items="orders"
               :tbody-tr-class="rowClass"
               :per-page="10"
               :current-page="currentPageOrderList"
               :filter="orderListFilter"
               :fields="[
                                 {key: 'customerOrderNumber', label: 'Order Number', sortable: true},
                                 {key: 'comment', label: 'Comment', sortable: true},
                                 {key: 'articleImage', label: 'Image', sortable: true},
                                 {key: 'article', label: 'PB Article', sortable: true},
                                 {key: 'color', label: 'PB Color', sortable: true},
                                 {key: 'customerArticle', label: 'Article', sortable: true},
                                 {key: 'size', label: 'Size', sortable: true},
                                 {key: 'customerColor', label: 'Color', sortable: true},
                                 {key: 'openQuantity', label: 'Open qty', sortable: true},
                                 {key: 'desiredDate', label: 'Requested', sortable: true},
                                 {key: 'confirmedDate', label: 'Confirmed', sortable: true},
                                 {key: 'diff', label: '∆', sortable: true},]">
         <template #head(orderCreatedAt)="data">
            <span class="text-nowrap">{{ data.label }}</span>
         </template>
         <template v-slot:cell(desiredDate)="row">
            <span>{{ row.item.desiredDate | moment("DD.MM.YYYY") }}</span>
         </template>
         <template v-slot:cell(confirmedDate)="row">
            <nobr>
                                <span>
                                    {{ row.item.confirmedDate | moment("DD.MM.YYYY") }}
                                </span>
               <i v-if="row.item.firstConfirmedDate && row.item.confirmedDate !== row.item.firstConfirmedDate"
                  v-b-tooltip.hover
                  :title="row.item.firstConfirmedDate ? `First confirmed for ${moment(row.item.firstConfirmedDate).format('DD.MM.YYYY')} (update from ${moment(row.item.confirmedDateUpdatedAt).format('DD.MM.YYYY')})` : ''"
                  class="fa fa-exclamation-circle"></i>
            </nobr>
         </template>
         <template v-slot:cell(articleImage)="row">
            <img :src="imageResource((row.item.articleImage), 50)"
                 alt="thumbnail"/>
         </template>
         <template v-slot:cell(size)="row">
            <span v-if="row.item.customerSize">{{ row.item.customerSize }}</span>
            <span v-else>{{ row.item.size }}</span>
         </template>
         <template v-slot:cell(orderType)="row">
            <span>{{ $t("order_type_" + row.item.orderType) }}</span>
         </template>
         <template v-slot:cell(orderStatus)="row">
            <span>{{ $t("order_status_" + row.item.orderStatus) }}</span>
         </template>
         <template v-slot:cell(diff)="row">
            <span v-if="row.item.diff !== 0">{{ row.item.diff }}</span>
         </template>

         <template v-slot:cell(confirmedDateUpdatedAt)="row">n
            <span>{{ row.item.confirmedDateUpdatedAt | moment("DD.MM.YYYY") }}</span>
         </template>

         <template v-slot:cell(comment)="row">
            <div class="d-inline-block text-truncate" v-b-tooltip.hover :title="row.item.comment"
                 style="max-width: 80px;">
               {{ row.item.comment }}
            </div>
         </template>
      </b-table>
      <b-pagination
          v-model="currentPageOrderList"
          :total-rows="orders.length"
          :per-page="10"
          aria-controls="my-table"
      ></b-pagination>
   </div>
</template>

<script>
import OrderApi from "@shared/_api/order";
import moment from 'moment';

export default {
   name: 'customer-orders',
   data: function () {
      return {
         moment: moment,
         currentPageOrderList: 1,
         loadingOrderList: false,
         orderList: [],
         orderListFilter: null,
         selectedOrderType: ['PRODUCTION', 'SAMPLE'],
         customerOrderNumberFilter: null,
         articleFilter: null,
         customerArticleFilter: null
      }
   },
   computed: {
      orders: function () {
         return this.$_.orderBy(this.orderList.filter(order => {
            let orderTypeTest = [...this.selectedOrderType];
            if (orderTypeTest.includes('PRODUCTION')) {
               orderTypeTest.push('RETRIEVAL');
            }

            return (orderTypeTest ? orderTypeTest.includes(order.orderType) : true)
                && (this.articleFilter ? order.article.includes(this.articleFilter) : true)
                && (this.customerOrderNumberFilter ? order.customerOrderNumber.includes(this.customerOrderNumberFilter) : true)
                && (this.customerArticleFilter ? order.customerArticle.includes(this.customerArticleFilter) : true);
         }), [this.rowClass, 'confirmedDateUpdatedAt'], ['asc', 'desc']);
      },
   },
   methods: {
      rowClass(item, type) {
         if (item.firstConfirmedDate && item.confirmedDate !== item.firstConfirmedDate) {
            return 'font-weight-bold'
         }
         return;
      },
     loadOrders(categoryId) {
        this.loadingOrderList = true;
        OrderApi.fetchOrderList(categoryId).then(orderList => {
           this.orderList = this.$_.orderBy(orderList.filter(o => o.orderStatus !== "FINISHED" && o.openQuantity > 0), ['orderCreatedAt'], ['desc']);
        }).finally(() => {
           this.loadingOrderList = false;
        });
     }
   },
   created() {
      this.loadOrders(this.$route.params.id);
   },
   beforeRouteUpdate(to, from, next) {
      this.loadOrders(to.params.id);
      next();
   }
}
</script>